module.exports = jQuery;


//////////////////
// WEBPACK FOOTER
// external "jQuery"
// module id = jquery
// module chunks = 1